import { useTranslation } from 'react-i18next'
import BasicModal from '@/components/UI/Dialog'
import { Button, Stack } from '@mui/material'
import KGroupsTree from '@/components/UI/KGroupsTree'
import { useState } from 'react'

const SelectModalModule = (props: any) => {
  const { t } = useTranslation('translation')
  const [selectedGroupId, setSelectedGroupId] = useState<string | null>(null)

  const confirmCategoryUpdatehandler = (
    extraParams: boolean = false,
    key: string,
  ) => {
    props.confirmCategoryUpdate(selectedGroupId, extraParams, key)
  }

  return (
    <BasicModal
      open={props.show}
      onClose={props.onHide}
      showCloseButton
      title={props.header ? props.header : ''}
      sx={{ padding: 2 }}
    >
      <Stack sx={{ height: 'calc(100% - 56px)' }} spacing={2} mt={2}>
        <div className="tw-overflow-y-auto">
          <KGroupsTree
            syncsState={false}
            onSelectGroup={(group: any) =>
              setSelectedGroupId(group?._id || null)
            }
          />
        </div>
        <Stack direction="row" justifyContent="flex-end" spacing={2} mt={2}>
          <Button variant="outlined" onClick={props.onHide}>
            {t('Close')}
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              confirmCategoryUpdatehandler(false, props.selectedFlow)
            }}
          >
            {t('Save Changes')}
          </Button>
        </Stack>
      </Stack>
    </BasicModal>
  )
}

export default SelectModalModule
